module.exports = __webpack_public_path__ + "static/media/business-hub-secondary.4980f820.jpg";